

import moment from 'moment';

export function fncChangeDateToJPFormat(dateTarget: Date): string {
  const m = moment(dateTarget);
  return m.format('YYYY年MM月DD日').toString();
}

export function fncChangeDateToJPFormatNonZero(dateTarget: Date): string {
  const m = moment(dateTarget);
  return m.format('YYYY年M月D日').toString();
}

export function fncChangeStringToJPFormat(dateTarget: string): string {
  const m = moment(dateTarget);
  return m.format('YYYY年MM月DD日').toString();
}

export function fncChangeStringToJPFormatNonZero(dateTarget: string): string {
  const m = moment(dateTarget);
  return m.format('YYYY年M月D日').toString();
}

export function fncChangeDateToInputForm(dateTarget: Date): string {
  const m = moment(dateTarget);
  return m.format('YYYY-MM-DD').toString();
}

export function fncChangeDateToInputFormNonHyphen(dateTarget: Date): string {
  const m = moment(dateTarget);
  return m.format('YYYYMMDD').toString();
}

export function fncChangeMonthToInputForm(dateTarget: Date): string {
  const m = moment(dateTarget);
  return m.format('YYYY-MM').toString();
}

export function fncChangeDateDBFormat(dateTarget: string): Date {
  const m = moment(dateTarget, 'YYYY-MM-DD');
  return m.toDate();
}

export function fncChangeCustomDayInputForm(dateTarget: Date): string {
  const m = moment(dateTarget);
  return m.format('YYYY/MM/DD').toString();
}

export function fncChangeCustomDayDBFormat(dateTarget: string): Date {
  // const m = moment(dateTarget.replace(/\//g,'-'));
  const m = moment(dateTarget, 'YYYY/MM/DD');
  return m.toDate();
}

export function fncChangeDateDBFormatFromNonHyphen(dateTarget: string): Date {
  const m = moment(dateTarget, 'YYYYMMDD');
  return m.toDate();
}

export function fucChangeDateListFormat1(dateTarget: string): string {
  const m = moment(dateTarget);
  return m.format('YYYY/MM/DD');
}

export function fucChangeDateListFormat2(dateTarget: string): string {
  const m = moment(dateTarget);
  return m.format('YYYY.M.D');
}

export function fncChangeCustomTimeInputForm(timeTarget: Date): string {
  const m = moment(timeTarget);
  return m.format('HH:mm:ss').toString();
}

export function fncChangeTime15(timeTarget: string): number {
  const hms = timeTarget.split(':');
  return Number(hms[0]) * 4 + Math.floor(Number(hms[1]) / 15) ;
}

export function fncChange15Time(timeTarget: number): string {
  // const hms = timeTarget.split(':');
  // return Number(hms[0]) * 4 + Math.floor(Number(hms[1]) / 15) ;
  return '';
}

export function fncChangeLogDate(dateTarget: Date): string {
  const m = moment(dateTarget);
  return m.format('YYYY/MM/DD HH:mm:ss').toString();
}

export function fncGetDaysArray(start: Date, end: Date) {
  const arr = [] as Date[];
  for (const dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(dt));
  }
  return arr;
}

export function fncGetDaysArrayStr(start: Date, end: Date) {
  const arr = [] as Date[];
  for (const dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(dt));
  }
  return arr.map((v) => (v.toISOString().substr(0, 10)));
}

export function fncGetStrDaysArrayStr(start: string, end: string) {
  const arr = [] as Date[];
  for (const dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(dt));
  }
  return arr.map((v) => (v.toISOString().substr(0, 10)));
}


export function fncGetThisYear(today?: string): string {
  const date = today ? new Date(today) : new Date();
  return fncChangeDateToInputForm(new Date()).substr(0, 4);
}

export function fncGetLastMonthStr(today?: string): string {
  const date = today ? new Date(today) : new Date();
  return fncChangeDateToInputForm(new Date(date.getFullYear(), date.getMonth() - 1, date.getDate())).substr(0, 7);
}

export function fncGetMonthStr(today?: string): string {
  const date = today ? new Date(today) : new Date();
  return fncChangeDateToInputForm(new Date(date.getFullYear(), date.getMonth(), date.getDate())).substr(0, 7);
}

export function fncGetLastMonthDateStr(today?: string): string {
  const date = today ? new Date(today) : new Date();
  return fncChangeDateToInputForm(new Date(date.getFullYear(), date.getMonth() - 1, date.getDate()));
}
// 月の初日(1日)を取得する
export function funcGetFirstDayOfMonth(today?: string): string {
 const date = today ? new Date(today) : new Date();
 return fncChangeDateToInputForm(new Date(date.getFullYear(), date.getMonth(), 1));
}


export function fncGetYesterDay(today?: string): string {
  const date = today ? new Date(today) : new Date();
  return fncChangeDateToInputForm(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1));
}

export function fncChangeTimeNumber(time: string): number {
  const timeArray = time.split(':');
  return Number(timeArray[0]) * 60 + Number(timeArray[1]);
}

export function fncChangeNumberTime(time: number): string {
  return `${Math.floor((time / 60)).toString()}:${(time % 60).toString().replace('-', '')}:00`;
}


